var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUpIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.47 16.0299L12 9.55994L5.52997 16.0299L4.46997 14.9699L12 7.43994L19.53 14.9699L18.47 16.0299Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronUpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chevron_Up_Icon.486e68d22e35860e037cd3298e2d6936.svg";